<template>
<v-btn elevation="2" fab v-if="notification_counter > 0" @click="goToNotifications">
    <v-icon>
        mdi-bell
    </v-icon>
    <span>{{ notification_counter }}</span>

</v-btn>
</template>

<script>
import {
    mapState
} from "vuex";

export default {
    methods: {
        goToNotifications() {
            this.$router.push('/notifications');

        }
    },
    computed: mapState({
        notification_counter: (state) => {
            if (state.notifications?.notifications?.length) {
                return state.notifications?.notifications.filter(e => e.unread == true).length
            }

            return 0
        },
    }),
};
</script>
